export default __webpack_public_path__ + "static/media/arrowConversation.2b8aed59.svg";